import type { MotivoDeSaida } from './api.ts';

/**
 * Por que a sessão terminou — para a tela de entrada poder dizer.
 *
 * Sair do sistema não é sempre a mesma coisa, e a diferença importa para quem
 * está olhando: "expirou" se resolve entrando de novo, e "outra conta entrou
 * neste navegador" avisa que **havia outra pessoa** — ou outra empresa — no
 * mesmo Chrome, o que é informação de segurança e não recado de rotina.
 *
 * Módulo próprio, e não o `flash`: aquele fala o vocabulário de gravação
 * (`sucesso`/`atenção`/`erro`, com o rótulo "Não foi possível salvar") e é lido
 * pela faixa que mora **dentro** do shell. Este é lido pela tela de entrada, que
 * fica do lado de fora e não tem faixa nenhuma.
 *
 * Como o `flash`, vive em memória e some no F5: o motivo explica a saída que
 * acabou de acontecer, e reaparecer meia hora depois seria mentira.
 */

let pendente: MotivoDeSaida | null = null;

export function registrarSaida(motivo: MotivoDeSaida): void {
  pendente = motivo;
}

/**
 * Lê o motivo **sem** apagá-lo.
 *
 * Separado do descarte pelo mesmo motivo do `flash`: em StrictMode o
 * inicializador de `useState` roda duas vezes, e uma função que lesse e
 * limpasse de uma vez devolveria o motivo na primeira chamada e `null` na
 * segunda — que é a que vale.
 */
export function lerMotivoDeSaida(): MotivoDeSaida | null {
  return pendente;
}

export function limparMotivoDeSaida(): void {
  pendente = null;
}

/** O que a tela de entrada escreve para cada motivo. */
export const TEXTO_DA_SAIDA: Readonly<Record<MotivoDeSaida, string>> = {
  sessao_encerrada: 'Sua sessão expirou. Entre novamente.',
  outra_conta:
    'Outra conta entrou neste navegador e assumiu a sessão desta aba. Entre novamente para continuar na sua.',
};
